import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import GridLayoutResizeControls from '../../components/GridLayoutResizeControls';
import PegboardDndCellsContainer from './PegboardDndCellsContainer';
import { useTransitionStyles } from 'layout-dnd-utils/TransitionStyles/TransitionStylesContext';
import { getCurrentDragItem, getSelectedItemPositionInfo } from '../../redux/selectors/layoutSectionDndSelectors';
import { getSelectedGridLayoutModuleNode } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import GridDndOverlayContainer from './GridDndOverlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PegboardDndContainer = () => {
  const [containerId, setContainerId] = useState('');
  const [gridLayoutId, setGridLayoutId] = useState('');
  const currentDragItem = useSelector(getCurrentDragItem);
  const transitionStylesManager = useTransitionStyles();
  useEffect(() => {
    if (!currentDragItem && transitionStylesManager) {
      transitionStylesManager.clearTransitionStyles();
    }
  }, [currentDragItem, transitionStylesManager]);
  const selectedItemPositionInfo = useSelector(getSelectedItemPositionInfo);
  const selectedGridLayoutModuleNode = useSelector(getSelectedGridLayoutModuleNode);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridDndOverlayContainer, {}), /*#__PURE__*/_jsx(PegboardDndCellsContainer, {
      containerId: containerId,
      gridLayoutId: gridLayoutId
    }), selectedGridLayoutModuleNode && selectedItemPositionInfo && /*#__PURE__*/_jsx(GridLayoutResizeControls, {
      setContainerId: setContainerId,
      setGridLayoutId: setGridLayoutId,
      selectedGridLayoutModuleNode: selectedGridLayoutModuleNode,
      selectedItemPositionInfo: selectedItemPositionInfo
    })]
  });
};
export default PegboardDndContainer;